import React from 'react';
import { Hero } from '../components/Hero';
import { Stats } from '../components/Stats';
import { Services } from '../components/Services';
import { Events } from '../components/Events';
import { PilotInfo } from '../components/PilotInfo';
import { Contact } from '../components/Contact';
export function HomePage() {
  return <>
      <Hero data-id="element-560" data-mp="3kqmn5h94mv4f" />
      <Stats data-id="element-561" data-mp="3kquy33lovqcz" />
      <Services data-id="element-562" data-mp="3ko8uff1x5v01" />
      <Events data-id="element-563" data-mp="2x094uigcgan1" />
      <PilotInfo data-id="element-564" data-mp="2wzz9sggfzdah" />
      <Contact data-id="element-565" data-mp="2x1k4q76o4y8v" />
    </>;
}